var map = {
	"./data-icon.png": "6adf",
	"./expenses.png": "b315",
	"./house.png": "f62b",
	"./incomes.png": "e812",
	"./men.png": "5c70",
	"./nse-a.png": "1f2d",
	"./nse-b.png": "f703",
	"./nse-c.png": "76be",
	"./nse-d.png": "6f23",
	"./nse-e.png": "4b17",
	"./nse-x.png": "112c",
	"./population.png": "7591",
	"./women.png": "3108"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fbe6";